module.exports = __webpack_public_path__ + "media/images/CrossElasticityDisabled-5939fbd4409ec733a05ee19dc115810f.png";